import { Box, styled } from "@mui/material";

export const BoxFormTitleAction = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "1px solid #00000020",
  padding: "8px",
  boxSizing: "border-box",
}));
